
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

const EditArticleLoading = () => (
  <div className="flex justify-center p-12">
    <div className="animate-pulse flex flex-col items-center">
      <div className="h-6 w-32 bg-gray-200 rounded mb-4"></div>
      <div className="h-4 w-48 bg-gray-200 rounded mb-6"></div>
      <div className="h-4 w-64 bg-gray-200 rounded"></div>
    </div>
  </div>
);

export default EditArticleLoading;
